<template>
  <v-form v-model="valid">
    <v-row>
      <v-text-field
        :disabled="disabled"
        class="mx-8 mt-8"
        outlined
        label="IBAN *"
        :rules="ibanRules"
        v-model="banking.iban"
      />
    </v-row>
    <v-row>
      <v-text-field
        :disabled="disabled"
        class="mx-8"
        outlined
        label="Bank *"
        :rules="requiredRules"
        v-model="banking.bank"
      />
    </v-row>
    <v-row>
      <v-text-field
        :disabled="disabled"
        class="mx-8"
        outlined
        label="Kontoinhaber *"
        :rules="requiredRules"
        v-model="banking.name"
      />
    </v-row>
    <profile-confirmation-row v-if="!isDisabled" :isLoading="isLoading" :valid="valid" @save="save" @abort="abort" />
    <v-card-actions v-if="isDisabled">
      <v-spacer />
      <v-btn :loading="isLoading" color="primary" @click="isDisabled = !isDisabled" data-test-profile-edit>
        {{ $t("components.profile.EditProfileDialog.edit") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script lang="ts">
import { ibanRule } from "@/lib/rules/ibanRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgBankingDtoGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import ProfileConfirmationRow from "./ProfileConfirmationRow.vue";

@Component({
  components: { ProfileConfirmationRow }
})
export default class ProfileBankingForm extends DarkModeHighlightMixin {
  @Prop()
  banking!: ThgBankingDtoGen;

  @Prop()
  disabled!: boolean;

  @Prop({ default: false })
  isLoading!: boolean;

  valid = false;

  get isDisabled() {
    return this.disabled;
  }

  set isDisabled(disabled: boolean) {
    this.$emit("update:disabled", disabled);
  }

  get ibanRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(ibanRule());

    return rules;
  }

  get requiredRules() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  save() {
    this.$emit("save");
  }

  abort() {
    this.$emit("update:disabled", true);
  }
}
</script>
